import datepicker from './datepicker.js';
import formValidation from './formValidation.js';
import selectValue from './selectValue.js';

const modal = {

	/**
	 * Initialisseer de modal functie
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {
		// Bind permission buttons met changePermission function
		target.addEventListener('click', function(event) {
			if (event.target.matches('[data-toggle=content-modal], [data-toggle-content-modal]')) {
				event.preventDefault();
				modal.getModal(event);
			}
		});
	},

	/**
	 * Toon en verberg modal
	 *
	 * @param {object} event
	 * @return {void}
	 */
	getModal: function(event) {

		// Verkrijg modal in DOM
		var m = $('#generalModal');

		// Verberg de huidige content in de modal
		m.find('.modal-title').addClass('d-none');
		m.find('.modal-spinner').removeClass('d-none');
		m.find('.modal-body').addClass('d-none');

		// Verkrijg target elements uit DOM
		var target = $(event.target);

		// Verkrijg data uit event
		var param1 = target.attr('data-content-modal-param1');
		var param2 = target.attr('data-content-modal-param2');
		var title = target.attr('data-content-modal-title');
		var errorMessage = target.attr('data-content-modal-error-message') || 'Er ging iets mis, probeer het later nogmaals';
		var contentContainerTarget = target.attr('data-content-modal-content-target');
		var content;

		// Verberg titel van modal in DOM als er geen titel gedefineerd is
		m.find('.modal-title').html(title);
		if ((typeof title == 'undefined') || (title == '')) {
			m.find('.modal-title').addClass('d-none');
		}

		// Verberg altijd de footer van de modal
		m.find('.modal-footer').addClass('d-none');

		// Gebruik de data id om content met AJAX  te laden of vul de modal met content uit de dom
		if ((typeof param1 != 'undefined') && (param1 != '')) {

			// Verkrijg de sub id uit de DOM en pas deze toe
			if ((typeof param2 == 'undefined') || (param2 == '')) {
				param2 = '';
			}

			// Verkrijg de link uit de DOM en pas deze toe
			var path = target.attr('data-content-modal-path');
			if ((typeof path == 'undefined') || (path == '')) {
				path = 'data';
			}

			// Verkrijg het formaat van de modal uit de DOM en pas deze toe
			var size = target.attr('data-content-modal-size');
			if ((typeof size != 'undefined') && (size != '')) {
				size = 'modal-' + size;
				m.find('.modal-dialog').removeClass('modal-sm').addClass(size);
			}

			// Verkrijg de data URL uit de DOM en verkrijg de data met AJAS
			var url = window.app.url;
			var urlFull = url + path + '/' + param1 + '/' + param2;

			$.get(urlFull, function(data) {
				if (data != 'false' && data != '') {
					content = data;
				}

				// Toon de content in de modal
				m.find('.modal-body').html(content).hide().removeClass('d-none').fadeIn(200);
				m.find('.modal-spinner').addClass('d-none');
				m.find('.modal-title').hide().removeClass('d-none').fadeIn(200);

				// Init eventuele form elementen
				let formElement = m.find('.modal-body form');
				if (formElement.length) {
					selectValue.init(m.find('.modal-body form'));
					datepicker.init(m.find('.modal-body form'));
					formValidation.init(m.find('.modal-body form'));
				}

			});

		} else {

			// Vul de modal met de content uit de DOM of geef een foutmelding
			content = $(contentContainerTarget).html();
			if ((typeof content == 'undefined') || (content == '')) {
				content = errorMessage;
			}

			// Toon de content in de modal
			m.find('.modal-body').html(content).removeClass('d-none').fadeIn(200);
			m.find('.modal-spinner').addClass('d-none');
			m.find('.modal-title').removeClass('d-none').fadeIn(200);

		}

		// Toon de modal
		var bootstrapModal = new bootstrap.Modal(m);
		bootstrapModal.show();

	}

};

export default modal;
